var splideTexts = function (slideType) {
    if (slideType === void 0) { slideType = 'Slide'; }
    return {
        prev: 'Zurück',
        next: 'Weiter',
        first: "Zum ersten ".concat(slideType, " springen"),
        last: "Zum letzten ".concat(slideType, " springen"),
        slideX: "Zu ".concat(slideType, " %s springen"),
        pageX: 'Gehe zu Seite %s',
        play: 'Abspielen',
        pause: 'Anhalten',
        carousel: 'Slider',
        select: "Einen ".concat(slideType, " ausw\u00E4hlen"),
        slide: "".concat(slideType),
        slideLabel: '%s von %s',
    };
};
export { splideTexts };
